import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import RightIcon from '@mui/icons-material/ChevronRightOutlined';
import Switch from 'components/form/Switch';
import TextInput from 'components/form/TextInput';
import { Link } from 'react-router-dom';
import Button from 'components/Button';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

const ChatBubble = ({ id, chatOption, onInputChange, onRadioChange }) => {
  const [t] = useTranslation('groups');
  const { text, subtitle, enabled, position } = chatOption;
  const isEnabled = Boolean(enabled);
  return (
    <Box>
      <Typography variant="caption">
        {t(
          'scc-form-fab-desc',
          'This will display a chat bubble in the bottom corner of your website',
        )}
      </Typography>
      {isEnabled && (
        <>
          <TextInput
            fullWidth
            label="Headline"
            name="collection_settings.chat.text"
            value={text}
            onChange={onInputChange}
            placeholder={t('scc-form-fab-placeholder', 'Ex. Join Us')}
          />
          <TextInput
            fullWidth
            multiline
            rows={2}
            margin="dense"
            label="Description"
            name="collection_settings.chat.subtitle"
            value={subtitle}
            onChange={onInputChange}
            placeholder={t(
              'scc-form-fab-desc-placeholder',
              'Ex. Preregister your kids and we’ll make sure our staff is ready.',
            )}
          />
          <Box mt={2}>
            <ToggleButtonGroup
              exclusive
              fullWidth
              color="primary"
              size="small"
              onChange={(e, value) =>
                value &&
                onInputChange({
                  target: {
                    name: 'collection_settings.chat.position',
                    value,
                  },
                })
              }
              value={position}
            >
              <ToggleButton value="left">Left</ToggleButton>
              <ToggleButton value="right">Right</ToggleButton>
            </ToggleButtonGroup>
          </Box>
        </>
      )}
    </Box>
  );
};

export default ChatBubble;
